
export const optionsLevelPermission = [
	{ name: 'Visualizador', value: "Viewer" },
	{ name: 'Aprovador em Conjunto', value: "JointApprover" },
	{ name: 'Aprovador Master', value: "MasterApprover" }
];